import { StateStorage } from "zustand/middleware";

const hashStorage: StateStorage = {
  getItem: (key): string => {
    const searchParameters = new URLSearchParams(globalThis.location.hash.slice(1));
    const storedValue = searchParameters.get(key) ?? "";
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return JSON.parse(storedValue);
  },
  removeItem: (key): void => {
    const searchParameters = new URLSearchParams(globalThis.location.hash.slice(1));
    searchParameters.delete(key);
    globalThis.location.hash = searchParameters.toString();
  },
  setItem: (key, newValue): void => {
    const searchParameters = new URLSearchParams(globalThis.location.hash.slice(1));
    searchParameters.set(key, JSON.stringify(newValue));
    globalThis.location.hash = searchParameters.toString();
  },
};

export default hashStorage;
